import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function OtpModal({
    otpModal,
    handleModalClose,
    handleOtpChange,
    loadingActive,
    otp,
    handleProceed,
    resendOtp
}) {
    const [timer, setTimer] = useState(30);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const firstInputRef = useRef(null);

    useEffect(() => {
        let interval = null;
        if (isResendDisabled && timer > 0) {
            interval = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
        } else if (timer === 0) {
            setIsResendDisabled(false);
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isResendDisabled, timer]);

    useEffect(() => {
        if (otpModal) {
            if (firstInputRef.current) {
                firstInputRef.current.focus();
            }
        }
    }, [otpModal]);

    useEffect(() => {
        const handlePaste = (event) => {
            const paste = event.clipboardData.getData('text');
            if (paste.length === 6 && !isNaN(paste)) {
                event.preventDefault();
                const newOtp = paste.split('');
                handleOtpChange(newOtp.join(''));
                Array.from(document.querySelectorAll('.otp-input')).forEach((input, i) => {
                    input.value = newOtp[i] || '';
                });
            }
        };

        const inputs = document.querySelectorAll('.otp-input');
        inputs.forEach(input => input.addEventListener('paste', handlePaste));
        return () => {
            inputs.forEach(input => input.removeEventListener('paste', handlePaste));
        };
    }, [otpModal]);

    const otpInputStyle = {
        width: '3rem',
        height: '3rem',
        textAlign: 'center',
        fontSize: '1.5rem',
        margin: '0 0.25rem',
        border: '1px solid black'
    };

    const handleOtpChangeFn = (element, index) => {
        const value = element.value.replace(/\D/g, ''); // Remove non-digit characters
        let newOtp = otp.split('');

        if (value.length === 1) {
            newOtp[index] = value;
            handleOtpChange(newOtp.join(''));
            if (value && element.nextSibling) {
                element.nextSibling.focus();
            }
        } else if (value === "") {
            newOtp[index] = value;
            handleOtpChange(newOtp.join(''));
            if (element.previousSibling) {
                element.previousSibling.focus();
            }
        }
    };

    const handleKeyDown = (event, index) => {
        if (event.key === 'Backspace' && (otp[index] === undefined || otp[index] === "")) {
            if (event.target.previousSibling) {
                event.target.previousSibling.focus();
                let newOtp = otp.split('');
                newOtp[index - 1] = ""; // Clear the previous input
                handleOtpChange(newOtp.join(''));
            }
        }
    };

    const handleResendClick = () => {
        setIsResendDisabled(true);
        setTimer(30);
        resendOtp();
    };

    return (
        <Modal className="fade" show={otpModal} centered>
            <form
            onSubmit={(e)=>{
            e.preventDefault()
            handleProceed()
            }}
            >
            <Modal.Header>
                <Modal.Title>Please enter OTP to proceed</Modal.Title>
                <Button
                    onClick={handleModalClose}
                    variant=""
                    className="btn-close"
                ></Button>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-center mt-3">
                    {[...Array(6)].map((_, index) => (
                        <input
                            className="form-control otp-input"
                            type="text"
                            name="otp"
                            maxLength="1"
                            key={index}
                            defaultValue={otp[index] || ""}
                            onChange={e => handleOtpChangeFn(e.target, index)}
                            onKeyDown={e => handleKeyDown(e, index)}
                            onFocus={e => e.target.select()}
                            style={otpInputStyle}
                            ref={index === 0 ? firstInputRef : null}
                        />
                    ))}
                </div>
                {!isResendDisabled && 
                    <div 
                        className="d-flex justify-content-center mt-3" 
                        style={{ width: '100%', cursor: 'pointer' }} 
                        onClick={handleResendClick}
                    >
                        <span style={{ color: 'black', textDecoration: 'underline' }}>Resend OTP</span>
                    </div>
                }
                {isResendDisabled && 
                    <div className="d-flex justify-content-center mt-3" style={{ width: '100%', cursor: 'pointer' }}>
                        <span style={{ color: 'black' }}>You can resend otp after {timer} seconds</span>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    type='submit'
                    disabled={otp.length !== 6 || loadingActive}
                >
                    {loadingActive ? "Validating" : "Validate"}
                </Button>
            </Modal.Footer>
            </form>
        </Modal>
    );
}
